import createImmutableSelector from 'lib/immutable/selector'
import { IPortfolio } from '../models'

// TODO: import Store type and add reducer type in Store interface
const getPortfolio = (state: any): IPortfolio => state.get('portfolioReducer')

export const portfolioSelector = createImmutableSelector(getPortfolio, (portfolio) => portfolio)
export const portfolioItemsSelector = createImmutableSelector(getPortfolio, (portfolio) => portfolio.get('items'))
